export default __webpack_public_path__ + "static/media/13.ca92de68.png";